<template>
    <CustomDialog
        :value="value"
        @input="$emit('input', $event)"
        :defaultTitle="modalTitle"
        :heightClass="`ppv2-max-h-[85vh]`"
        centerContent
    >
        <template #content>
            <div class="ppv2-grid ppv2-grid-cols-2" :style="{ gap: normalizeSize(16, true) }">
                <!-- Name -->
                <BaseInput
                    v-model="tagsForm.name"
                    :label="$t('tags.form.name_label')"
                    :placeholder="$t('tags.form.name_placeholder')"
                    required
                    classContainerAdd="ppv2-w-full"
                    :error="errors.name ? errors.name[0] : null"
                />

                <!-- Printer Selection -->
                <BaseSelect
                    v-model="tagsForm.printer_id"
                    :label="$t('tags.form.printer_label')"
                    :placeholder="$t('tags.form.printer_placeholder')"
                    :options="printersOptions"
                    optionLabel="device_name"
                    optionValue="id"
                    classAdded="borderInput"
                    :error="errors.printer_id ? errors.printer_id[0] : null"
                    fixedDropdown
                />

                <div class="isNotrequired">
                    <BaseLabel :label="$t('tags.form.status_label')" />
                    <div class="ppv2-mt-2">
                        <button
                            @click="tagsForm.active = !tagsForm.active"
                            class="ppv2-inline-flex ppv2-items-center ppv2-gap-3 ppv2-px-4 ppv2-py-2 ppv2-rounded-xl ppv2-border ppv2-transition-all"
                            :class="
                                tagsForm.active
                                    ? 'ppv2-border-[#206A64] ppv2-bg-[#06B217] ppv2-bg-opacity-20'
                                    : 'ppv2-border-[#4E4E4E] ppv2-bg-[#474747] ppv2-bg-opacity-20'
                            "
                        >
                            <div
                                class="ppv2-w-10 ppv2-h-5 ppv2-rounded-full ppv2-flex ppv2-items-center ppv2-transition-all"
                                :class="
                                    tagsForm.active
                                        ? 'ppv2-bg-[#206A64] ppv2-justify-end'
                                        : 'ppv2-bg-[#4E4E4E] ppv2-justify-start'
                                "
                            >
                                <div class="ppv2-w-4 ppv2-h-4 ppv2-bg-white ppv2-rounded-full ppv2-mx-0.5"></div>
                            </div>
                            <span class="poppinsRegular ppv2-text-gray-700">
                                {{ tagsForm.active ? $t('tags.form.status_active') : $t('tags.form.status_inactive') }}
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </template>
        <template #actions>
            <BaseButton
                variant="primary"
                @click="$emit('save')"
                :customClass="`!ppv2-h-[45px] !ppv2-min-w-[170px]`"
                :disabled="isSaving"
            >
                {{ isSaving ? $t('common.saving') : isEditMode ? $t('common.validate') : $t('common.add') }}
            </BaseButton>
        </template>
    </CustomDialog>
</template>

<script>
import normalizeSize from '../../../utils/normalizeSize'

import BaseButton from '../../Shared/BaseButton.vue'
import BaseInput from '../../Shared/BaseInput.vue'
import BaseSelect from '../../Shared/BaseSelect.vue'
import BaseLabel from '../../Shared/BaseLabel.vue'
import CustomDialog from '../../Shared/CustomDialog.vue'
export default {
    name: 'TagModal',
    components: {
        BaseButton,
        BaseInput,
        BaseSelect,
        BaseLabel,
        CustomDialog,
    },
    props: {
        value: { type: Boolean, required: true },
        isEditMode: { type: Boolean, default: false },
        isSaving: { type: Boolean, default: false },
        tagsForm: { type: Object, required: true },
        printersOptions: { type: Array, default: () => [] },
        errors: { type: Object, default: () => ({}) },
    },
    computed: {
        modalTitle() {
            return this.isEditMode ? this.$t('tags.form.modal_title_edit') : this.$t('tags.form.modal_title_create')
        },
    },
    methods: {
        normalizeSize,
    },
}
</script>
